import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  FiClock,
  FiUser,
  FiBell,
  FiCheckCircle,
} from "react-icons/fi";

import GuruLayout from "../../components/layout/GuruLayout";
import { usePopup } from "../../components/modal/Popup";
import { AuthContext } from "../../context/AuthContext";

const API = "https://backend.smpn1kamal.sch.id/api";

const JadwalKosong = () => {
  const { token } = useContext(AuthContext);

  const [jadwal, setJadwal] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    success: popSuccess,
    error: popError,
    PopupPortal,
  } = usePopup();

  useEffect(() => {
    fetchJadwalKosong();

    // AUTO REFRESH
    const interval = setInterval(() => {
      fetchJadwalKosong(false);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const fetchJadwalKosong = async (showLoading = true) => {
    try {
      if (showLoading) setLoading(true);

      const response = await axios.get(
        `${API}/pengganti/kosong-semua`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setJadwal(response.data.data || []);
    } catch (error) {
      console.error(error);

      if (showLoading) {
        popError(
          "Gagal",
          error.response?.data?.message || "Gagal mengambil data"
        );
      }
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  const handleAmbilJadwal = async (id) => {
    const confirmAmbil = window.confirm(
      "Apakah Anda yakin ingin mengambil jadwal ini?"
    );

    if (!confirmAmbil) return;

    try {
      const response = await axios.post(
        `${API}/pengganti/ambil`,
        {
          id_pengganti: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      popSuccess("Berhasil", response.data.message);

      fetchJadwalKosong(false);
    } catch (error) {
      console.error(error);

      popError(
        "Gagal",
        error.response?.data?.message || "Terjadi kesalahan"
      );
    }
  };

  return (
    <GuruLayout>
      {PopupPortal}

      <div className="space-y-3">

        {/* LOADING */}
        {loading ? (
          <div className="bg-white rounded-3xl p-10 shadow-sm flex justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-500"></div>
          </div>
        ) : jadwal.length === 0 ? (

          /* EMPTY */
          <div className="bg-white border border-dashed border-slate-300 rounded-3xl p-16 text-center shadow-sm">
            <div className="w-16 h-16 bg-slate-100 text-slate-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiBell size={28} />
            </div>

            <h3 className="text-lg font-bold text-slate-700">
              Tidak Ada Notifikasi
            </h3>

            <p className="text-sm text-slate-500 mt-1">
              Belum ada jadwal kosong saat ini.
            </p>
          </div>

        ) : (

          /* LIST */
          jadwal.map((item) => (
            <div
              key={item.id}
              className="relative overflow-hidden bg-white border border-slate-200 rounded-3xl px-5 py-5 shadow-sm hover:shadow-md transition-all"
            >

              {/* AKSEN KIRI */}
              <div className="absolute top-0 left-0 h-full w-1.5 bg-gradient-to-b from-blue-500 to-indigo-500"></div>

              {/* AKSEN KANAN */}
              <div className="absolute top-0 right-0 h-full w-1.5 bg-gradient-to-b from-indigo-400 to-blue-400 opacity-70"></div>

              <div className="flex items-center justify-between gap-4">

                {/* CONTENT */}
                <div className="min-w-0 flex-1">

                  {/* MAPEL + KELAS */}
                  <div className="flex items-center gap-2 flex-wrap">

                    <h2 className="text-sm md:text-[15px] font-bold text-slate-800 uppercase tracking-tight">
                      {item.nama_mapel}
                    </h2>

                    <span className="text-[10px] md:text-[11px] font-bold bg-blue-100 text-blue-600 px-2.5 py-1 rounded-full">
                      {item.nama_kelas}
                    </span>

                  </div>

                  {/* INFO */}
                  <div className="flex flex-wrap gap-x-4 gap-y-2 mt-2 text-xs md:text-sm text-slate-500">

                    <div className="flex items-center gap-1.5">
                      <FiClock size={13} />

                      {item.jam_mulai?.slice(0, 5)} -{" "}
                      {item.jam_selesai?.slice(0, 5)}
                    </div>

                    <div className="flex items-center gap-1.5">
                      <FiUser size={13} />

                      {item.nama_guru_asli}
                    </div>

                    <div className="flex items-center gap-1.5">
                      <FiClock size={13} />

                      {item.tanggal}
                    </div>

                  </div>

                  {/* STATUS */}
                  {item.status === "diambil" && (
                    <div className="flex items-center gap-2 mt-3 text-green-600 text-xs md:text-sm font-semibold">

                      <FiCheckCircle size={15} />

                      Sudah diambil oleh{" "}
                      <span className="font-bold">
                        {item.nama_guru_pengganti}
                      </span>

                    </div>
                  )}

                </div>

                {/* BUTTON */}
                <div className="shrink-0">

                  {item.status === "kosong" ? (
                    <button
                      onClick={() => handleAmbilJadwal(item.id)}
                      className="bg-indigo-500 hover:bg-indigo-600 text-white text-[11px] md:text-xs font-bold uppercase px-5 md:px-6 py-3 rounded-full transition-all active:scale-95 whitespace-nowrap"
                    >
                      Ambil Jadwal
                    </button>
                  ) : (
                    <div className="bg-green-100 text-green-600 text-[11px] md:text-xs font-bold px-4 md:px-5 py-3 rounded-full whitespace-nowrap">
                      Sudah Diambil
                    </div>
                  )}

                </div>

              </div>
            </div>
          ))

        )}
      </div>
    </GuruLayout>
  );
};

export default JadwalKosong;